@if (show) {
  <!--
  <mat-progress-bar
    [mode]="mode"
    [value]="progress"
  ></mat-progress-bar>
  -->

  <p-progressbar mode="indeterminate" [style]="{ height: '4px' }" />
}
